import caixaEntrada from '@/App/(authenticated)/modulos/analise/certificacao/caixa-entrada/caixa-entrada.vue'
import caixaEmCertificacao from '@/App/(authenticated)/modulos/analise/certificacao/caixa-em-certificacao/caixa-em-certificacao.vue'
import caixaCertificados from '@/App/(authenticated)/modulos/analise/certificacao/caixa-certificados/caixa-certificados.vue'
import emissaoCertificado from '@/App/(authenticated)/modulos/analise/certificacao/emissao-certificado/emissao-certificado.vue'

export const items = [
  {
    path: 'caixa-entrada',
    name: 'certificacao/caixa-entrada',
    component: caixaEntrada,
    meta: {
      routeGroup: 'certificacao/caixa-entrada'
    }
  },
  {
    path: 'em-certificacao',
    name: 'certificacao/em-certificacao',
    component: caixaEmCertificacao,
    meta: {
      routeGroup: 'certificacao/em-certificacao'
    }
  },
  {
    path: 'certificados',
    name: 'certificacao/certificados',
    component: caixaCertificados,
    meta: {
      routeGroup: 'certificacao/certificados'
    }
  },
  {
    path: 'emitir/:id',
    name: 'certificacao/emitir',
    component: emissaoCertificado,
    meta: {
      previousRoute: {
        meta: {
          routeGroup: 'certificacao/em-certificacao'
        }
      },
      routeGroup: 'certificacao/emitir'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/certificacao/routes.js